// extracted by mini-css-extract-plugin
module.exports = {"agreement":"index-module_agreement_1Hc-E"};